'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import AuthSessionLoadingSplash from '@/components/auth/AuthSessionLoadingSplash';
import { useAuthSession } from '@/lib/hooks/useAuthSession';

export default function RootPage() {
  const router = useRouter();
  const session = useAuthSession();

  useEffect(() => {
    if (session.isError) router.replace('/login');
  }, [router, session.isError]);

  return (
    <AuthSessionLoadingSplash data-component-id="src/app/page.tsx:17:4" data-component-path="src/app/page.tsx" data-component-line="17" data-component-end-line="20" data-component-file="page.tsx" data-component-name="AuthSessionLoadingSplash" data-component-content="%7B%22elementName%22%3A%22AuthSessionLoadingSplash%22%7D"
      session={session}
      onComplete={() => router.replace('/dashboard')}
    />
  );
}

